export class CSRFService {
  constructor(rpcService) {
    this.rpcService = rpcService;
  }

  /**
   * Get a CSRF token
   *
   * This is a void HTTP get call in which the HTTP response contains the 'csrfToken'
   * value that is automatically stored in the cookie.
   *
   * @returns {Promise<void>}
   */
  getToken() {
    return this.rpcService.invokeVoid("/api/service/csrfToken", null);
  }
}
//# sourceMappingURL=CSRFService.js.map
